module.exports = __webpack_public_path__ + "img/history.2bc12020.svg";